import { UserName } from "../../Users/shared/UserName.js";
import { MAIL_VIEWS } from "../constants.js";
import { useMailStore } from "../stores/MailStore.js";
import { UserAndGroupNames as UsersAndGroups } from "../../Users/shared/UserAndGroupNames.js";
import "react";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
// src/modules/Mail/components/MessageDisplayNames.tsx
function MessageDisplayNames({ message }) {
	if (useMailStore((state) => state.folder) === MAIL_VIEWS.INBOX) return /* @__PURE__ */ jsx(UserName, { user: message.sender });
	else if (Array.isArray(message.receiverUserAndGroups) && message.receiverUserAndGroups.length) return /* @__PURE__ */ jsx(UsersAndGroups, {
		max: 3,
		usersAndGroups: message.receiverUserAndGroups
	});
	else return /* @__PURE__ */ jsx(Fragment$1, { children: "'System'" });
}
export { MessageDisplayNames };

//# sourceMappingURL=MessageDisplayNames.js.map